var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, IconButton, Typography, useMediaQuery, useTheme } from '@mui/material';
import { Add01Icon, Delete02Icon, Edit02Icon } from 'hugeicons-react';
import { enqueueSnackbar } from 'notistack';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { AppConsts } from '../../../application/common/constants/app-consts';
import { RoleCategories } from '../../../application/common/constants/role-categories';
import { getFilteredStringOperators } from '../../../application/common/helpers/grid-filter-operators';
import { useDeleteMultipleFaqsMutation, useGetPaginatedFaqsQuery } from '../../../application/features/faqs/faq-api';
import { useGetMachinesListQuery } from '../../../application/features/machines/machine-api';
import { useAppSelector } from '../../../application/store/useStore';
import useTranslate from '../../../localization/helpers';
import ConfirmDialog from '../../components/ConfirmDialog';
import FilterButton from '../../components/FilterButton';
import PageHeaderButton from '../../components/PageHeaderButton';
import ProtectedElement from '../../components/ProtectedElement';
import TableClickableItem from '../../components/tableClickableItem';
import { Permissions } from '../../permissions';
import CreateFaq from './CreateFaq';
import FAQCards from './faqs-cards';
import { FaqsDatagrid } from './faqs-datagrid';
import FaqsDetails from './faqs-details';
import UpdateFaq from './UpdateFaq';
var Faqs = function () {
    var theme = useTheme();
    var _a = useTranslate(), translate = _a.translate, tWithFunction = _a.tWithFunction, tWithField = _a.tWithField;
    var currentUser = useAppSelector(function (state) { return state.auth; }).currentUser;
    var isSuperAdmin = currentUser.roleCategory === RoleCategories.SuperAdmin;
    var isXs = useMediaQuery(theme.breakpoints.only('xs'));
    var isMd = useMediaQuery(theme.breakpoints.only('md'));
    var isscreen600900 = useMediaQuery('(min-width:600px) and (max-width:900px)');
    var iscreen9001200 = useMediaQuery('(min-width:900px) and (max-width:1200px)');
    var isscreen600900Landscape = useMediaQuery('(min-width:600px) and (max-width:900px) and (orientation: landscape)');
    var isscreen9001200Landscape = useMediaQuery('(min-width:900px) and (max-width:1200px) and (orientation: landscape)');
    var isIpadMiniLandscape = useMediaQuery('(max-width: 1024px) and (orientation: landscape)');
    var isLg = useMediaQuery(theme.breakpoints.up('lg'));
    var isIpadMini = useMediaQuery('(max-width: 768px)');
    var _b = __read(useState(false), 2), addFaqModalOpen = _b[0], setAddFaqModalOpen = _b[1];
    var _c = __read(useState(false), 2), openFilterDrawer = _c[0], setOpenFilterDrawer = _c[1];
    var handleFilterClick = function () {
        setOpenFilterDrawer(function (prev) { return !prev; });
    };
    var _d = __read(useState({ isOpen: false }), 2), updateFaqModal = _d[0], setUpdateFaqModal = _d[1];
    var _e = __read(useState({ isOpen: false }), 2), deleteFaq = _e[0], setDeleteFaq = _e[1];
    var _f = __read(useState({ isOpen: false }), 2), faqDetailsDrawer = _f[0], setfaqDetailsDrawer = _f[1];
    var _g = __read(useState({
        machines: [],
        page: AppConsts.DEFAULT_PAGE_NUMBER,
        pageSize: AppConsts.DEFAULT_PAGE_SIZE,
        sortDirection: AppConsts.DEFAULT_SORT_DIRECTION,
        sortField: AppConsts.DEFAULT_SORT_FIELD,
        filterField: undefined,
        filterValue: undefined,
        filterOperator: undefined
    }), 2), faqFilters = _g[0], setFaqFilters = _g[1];
    var _h = useGetMachinesListQuery({
        filterByCompany: true,
        isMachineLibrary: false
    }), _j = _h.data, machinesList = _j === void 0 ? [] : _j, isMachinesFetching = _h.isLoading;
    var data = useGetPaginatedFaqsQuery(faqFilters, {
        refetchOnMountOrArgChange: true
    }).data;
    var _k = data !== null && data !== void 0 ? data : {}, _l = _k.items, faqs = _l === void 0 ? [] : _l, totalCount = _k.totalCount;
    var _m = __read(useDeleteMultipleFaqsMutation(), 2), triggerDeleteFaq = _m[0], _o = _m[1], isDeleteLoading = _o.isLoading, isDeleteSuccess = _o.isSuccess;
    var _p = useForm({
        defaultValues: {
            machines: []
        }
    }), control = _p.control, handleSubmit = _p.handleSubmit, reset = _p.reset, errors = _p.formState.errors;
    useEffect(function () {
        if (isDeleteSuccess)
            enqueueSnackbar(tWithField('toolTips.deleteSuccess', 'common.faqs'), {
                autoHideDuration: 3000,
                variant: 'success',
                anchorOrigin: { horizontal: 'right', vertical: 'top' }
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isDeleteSuccess]);
    var rowCountRef = useRef(totalCount !== null && totalCount !== void 0 ? totalCount : 0);
    var rowCount = useMemo(function () {
        if ((data === null || data === void 0 ? void 0 : data.totalCount) !== undefined) {
            rowCountRef.current = data === null || data === void 0 ? void 0 : data.totalCount;
        }
        return rowCountRef.current;
    }, [data]);
    var handleOpenAddFAQ = function () { return setAddFaqModalOpen(true); };
    var handleCloseAddFAQ = function () { return setAddFaqModalOpen(false); };
    var handleCloseUpdateFAQ = function () { return setUpdateFaqModal({ isOpen: false }); };
    var handlePaginationModelChange = function (model) {
        setFaqFilters(function (prev) { return (__assign(__assign({}, prev), { page: model.page + 1, pageSize: model.pageSize })); });
    };
    var handleSortModelChange = function (model) {
        setFaqFilters(function (prev) {
            var _a, _b, _c, _d;
            return (__assign(__assign({}, prev), { sortField: (_b = (_a = model[0]) === null || _a === void 0 ? void 0 : _a.field) !== null && _b !== void 0 ? _b : AppConsts.DEFAULT_SORT_FIELD, sortDirection: (_d = (_c = model[0]) === null || _c === void 0 ? void 0 : _c.sort) !== null && _d !== void 0 ? _d : AppConsts.DEFAULT_SORT_DIRECTION }));
        });
    };
    var onSearch = function (searchTerm) {
        setFaqFilters(__assign(__assign({}, searchTerm), { page: faqFilters.page, pageSize: faqFilters.pageSize, sortField: faqFilters.sortField, sortDirection: faqFilters.sortDirection }));
    };
    var onDeleteFaq = function (faqIds, machineName) {
        setDeleteFaq({ isOpen: true, machine: machineName, ids: faqIds });
    };
    var onDeleteConfirm = function () {
        triggerDeleteFaq({ ids: deleteFaq.ids });
        setDeleteFaq({ ids: [], machine: undefined, isOpen: false });
    };
    var handleFilterModelChange = function (model) {
        if (model.items.length > 0) {
            var filterItem_1 = model.items[0];
            if (filterItem_1.operator !== 'isEmpty' &&
                filterItem_1.operator !== 'isNotEmpty' &&
                (filterItem_1.value === '' ||
                    (Array.isArray(filterItem_1.value) && filterItem_1.value.length === 0) ||
                    filterItem_1.value === undefined)) {
                setFaqFilters(function (prev) { return (__assign(__assign({}, prev), { filterField: undefined, filterOperator: undefined, filterValue: undefined })); });
            }
            else {
                setFaqFilters(function (prev) {
                    var _a;
                    return (__assign(__assign({}, prev), { filterField: filterItem_1.field, filterOperator: filterItem_1.operator, filterValue: (_a = filterItem_1.value) === null || _a === void 0 ? void 0 : _a.toString() }));
                });
            }
        }
        else {
            // When model.items is empty, clear all filters
            setFaqFilters(function (prev) { return (__assign(__assign({}, prev), { filterField: undefined, filterOperator: undefined, filterValue: undefined })); });
        }
        setFilterModel(model);
    };
    var _q = __read(useState({
        items: []
    }), 2), filterModel = _q[0], setFilterModel = _q[1];
    var columns = __spreadArray(__spreadArray([
        {
            field: 'machineName',
            headerName: translate('common.asset'),
            flex: isXs ? undefined : isMd ? undefined : isscreen600900 ? undefined : 1,
            minWidth: isXs ? 150 : isscreen600900 ? 150 : isMd ? 150 : undefined,
            width: isXs ? 200 : isMd ? 200 : isscreen600900 ? 200 : undefined,
            filterOperators: getFilteredStringOperators()
        }
    ], __read((isSuperAdmin
        ? [
            {
                field: 'companyName',
                headerName: translate('common.company'),
                flex: isXs ? undefined : isMd ? undefined : isscreen600900 ? undefined : 1,
                minWidth: isXs ? 150 : isscreen600900 ? 150 : isMd ? 150 : undefined,
                width: isXs ? 200 : isMd ? 200 : isscreen600900 ? 200 : undefined,
                filterOperators: getFilteredStringOperators()
            }
        ]
        : [])), false), [
        {
            field: 'faqCount',
            headerName: translate('common.faqs'),
            align: 'right',
            headerAlign: 'right',
            filterable: false,
            flex: isXs ? undefined : isMd ? undefined : isscreen600900 ? undefined : 1,
            minWidth: isXs ? 150 : isscreen600900 ? 150 : isMd ? 150 : undefined,
            width: isXs ? 200 : isMd ? 250 : isscreen600900 ? 200 : undefined,
            renderCell: function (params) { return (_jsx(Box, { mt: 1, width: '100%', display: 'flex', justifyContent: 'flex-end', children: _jsx(TableClickableItem, { text: params.row.faqCount, onClick: function () { return setfaqDetailsDrawer({ faq: params.row, isOpen: true }); } }) })); }
        },
        {
            field: 'actions',
            disableColumnMenu: true,
            sortable: false,
            filterable: false,
            headerName: '',
            align: 'right',
            flex: 1,
            renderCell: function (params) { return (_jsxs("div", { style: {
                    display: 'flex',
                    justifyContent: 'flex-end',
                    alignItems: 'center'
                }, children: [_jsx(ProtectedElement, { permissions: [Permissions.Faqs.Update], children: _jsx(IconButton, { onClick: function () {
                                return setUpdateFaqModal({
                                    isOpen: true,
                                    machineId: params.row.machineId
                                });
                            }, color: 'default', size: 'small', children: _jsx(Edit02Icon, { size: 20 }) }) }), _jsx(ProtectedElement, { permissions: [Permissions.Faqs.Delete], children: _jsx(IconButton, { color: 'error', size: 'small', onClick: function () { return onDeleteFaq(params.row.faqIds, params.row.machineName); }, disabled: isDeleteLoading, children: _jsx(Delete02Icon, { size: 20 }) }) })] })); }
        }
    ], false);
    return (_jsxs(Box, { sx: {
            width: '100%',
            padding: isXs ? '16px' : '8px',
            display: 'flex',
            flexDirection: 'column',
            position: 'relative'
        }, children: [_jsxs(Box, { display: 'flex', alignItems: 'center', justifyContent: isXs || isscreen600900 || iscreen9001200 || isscreen600900Landscape ? 'space-between' : '', mb: { xs: 1, md: 2 }, children: [_jsxs(Box, { display: 'flex', alignItems: 'center', gap: 1, children: [_jsx(Typography, { variant: isXs ? 'h4' : 'h3', color: '#009983', children: translate('common.faqs') }), _jsx(ProtectedElement, { permissions: [Permissions.Faqs.Create], children: _jsx(PageHeaderButton, { text: translate('actions.add'), icon: _jsx(Add01Icon, { size: isXs ? 17 : undefined }), size: isXs ? 'small' : 'medium', onClick: handleOpenAddFAQ, variant: 'contained', color: 'primary', title: tWithFunction('actions.addFunction', 'common.faq') }) })] }), !isXs && !isIpadMini && !isIpadMiniLandscape && !isLg && (_jsx(FilterButton, { variant: 'soft', onClick: handleFilterClick }))] }), isXs || isIpadMini || isIpadMiniLandscape ? (_jsx(FAQCards, { faq: faqs, control: control, errors: errors, reset: reset, faqFilters: faqFilters, setFaqFilters: setFaqFilters, isMachinesFetching: isMachinesFetching, machinesList: machinesList, handleSubmit: handleSubmit, onSearch: onSearch, setUpdateFaqModal: setUpdateFaqModal, onDeleteFaq: onDeleteFaq, setfaqDetailsDrawer: setfaqDetailsDrawer, isXs: isXs })) : (_jsx(FaqsDatagrid, { faqs: faqs, rowCount: rowCount, columns: columns, control: control, errors: errors, isMachinesFetching: isMachinesFetching, machinesList: machinesList, handleSubmit: handleSubmit, onSearch: onSearch, openFilterDrawer: openFilterDrawer, faqFilters: faqFilters, filterModel: filterModel, onFilterModelChange: handleFilterModelChange, setOpenFilterDrawer: setOpenFilterDrawer, handlePaginationModelChange: handlePaginationModelChange, handleSortModelChange: handleSortModelChange, isXs: isXs, isscreen600900: isscreen600900, iscreen9001200: iscreen9001200, isscreen600900Landscape: isscreen600900Landscape, isscreen9001200Landscape: isscreen9001200Landscape })), faqDetailsDrawer.isOpen && faqDetailsDrawer.faq && (_jsx(FaqsDetails, { isOpen: faqDetailsDrawer.isOpen, onClose: function () { return setfaqDetailsDrawer({ isOpen: false }); }, machineId: faqDetailsDrawer.faq.machineId })), addFaqModalOpen && _jsx(CreateFaq, { isOpen: addFaqModalOpen, onClose: handleCloseAddFAQ }), updateFaqModal.isOpen && (_jsx(UpdateFaq, { machineId: updateFaqModal.machineId, isOpen: updateFaqModal.isOpen, onClose: handleCloseUpdateFAQ })), deleteFaq.isOpen && (_jsx(ConfirmDialog, { open: deleteFaq.isOpen, onClose: function () { return setDeleteFaq({ isOpen: false }); }, onConfirm: onDeleteConfirm, title: tWithFunction('actions.deleteFunction', 'common.faqs'), content: translate('faqs.deleteMultipleConfirmText', { field: deleteFaq.machine }), confirmButtonText: translate('actions.confirm'), closeButtonText: translate('actions.cancel'), mode: 'error' }))] }));
};
export default Faqs;
